import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TextField } from 'rmwc/TextField'
import { Card } from 'rmwc/Card'
import { Typography } from 'rmwc/Typography'
import { Grid, GridCell } from 'rmwc/Grid'
import { Button } from 'rmwc/Button'
import {ListDivider} from 'rmwc/List'
import * as api from '../../api/api'
import StatusMessage from '../../util/StatusMessage'

class AdminTriggerEmailNotification extends Component{

	constructor(){
		super()
		this.state = {
			data: {
				startDate: '',
				endDate: '',
			},
			userId: '',
			errorMsg: '',
			saveDisable: false,
			paramsType: '',
			eventName:'',
		}
	}

	componentDidMount(){
		let  currentTime = new Date()
    let m = currentTime.getMonth() + 1
    let d = currentTime.getDate()
    let y = currentTime.getFullYear()
    let currentDate = y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d)
		let data = Object.assign({}, this.state.data)
		data.startDate  = currentDate
		data.endDate = currentDate
		let name = this.props.match.params.type
		let eventName = name.charAt(0).toUpperCase() + name.slice(1)
		this.setState({data: data, paramsType: this.props.match.params.type, eventName: eventName})
	}

	onInputChange = (e) =>{

		let data = Object.assign({}, this.state.data)
		data[e.target.name] = e.target.value
		this.setState({data: data}) 
	}

	handleBack = (e) => {
		e.preventDefault()
		if(this.state.paramsType === 'report'){
  		this.props.history.push(`/portal/app/admin/tq/reports/home`)
  	}
	}

	handleRendering = (e) => {
		e.preventDefault()
		this.props.history.push('/portal/app/reg_user_details')
	}

	onHandleSubmit = (e) => {
		e.preventDefault()

		if(this.state.data.startDate === '' || this.state.data.endDate === ''){
			this.setState({errorMsg: 'Start Data and End Date is Mandatory'})
		}

		else if((this.state.data.endDate < this.state.data.startDate)){
			this.setState({errorMsg: 'Invalid Date.Check Start and End Date'})
		}

		else {
			if (this.state.paramsType === 'report'){
				let url = 'admin/notify/user/on/reports'
				let apiInput= {
					start_date: this.state.data.startDate,
					end_date: this.state.data.endDate,
				}
				api.postValuesApi(this.props.user.accessToken, url, apiInput).then((result) => {
					if(result.status === 'success'){
						this.setState({errorMsg: result.message, saveDisable: true})
					}
					else if(result.status === 'error'){
						this.setState({errorMsg: result.message})
					}
					else if(result.status === 'date_window_exceeded'){
						this.setState({errorMsg: result.message})
					}
				})
				.catch((err)=>{
					this.setState({ errorMsg: 'Exception.Error in Fetching Details' })
    		})
			}
		}
	}
		
	render(){
		let noteComponent
		if(this.state.paramsType === 'report'){
		noteComponent = (
			<GridCell span="12">
					<Typography use="caption">Note: Notification can be sent only for the past 5 days of TQ reports if any.</Typography>
			</GridCell>
			)
		}
		
		return(
			<div>
				<Card style={{padding: '20px'}}>
				 <Grid>
            <GridCell span="11" style={{textAlign: "center"}}>
              <Typography use="headline5">Notify Users on {this.state.eventName}</Typography>
            </GridCell>
            <GridCell span="1">
        			<Button raised onClick = {((e) => this.handleBack(e))}>Back</Button>
        		</GridCell>
        		<GridCell span="12">
        			<ListDivider/>
        		</GridCell>
          	<GridCell span="6">
          		<TextField  className="datepicker-padding" autoComplete="off" type='date' label="Start Date" name="startDate" onChange={this.onInputChange} value={this.state.data.startDate}/>
          	</GridCell>
          	<GridCell span="6">
          		<TextField  className="datepicker-padding" autoComplete="off" type='date' label="End Date" name="endDate" onChange={this.onInputChange} value={this.state.data.endDate}/>
          	</GridCell>
          	<GridCell span="12">
          		  <Typography use="headline7" onClick={(e) => this.handleRendering(e)} style={{color: 'blue',textDecorationLine: 'underline'}}> Edit User Email Preference </Typography>
          	</GridCell>
          	<GridCell span="12">
          		<Button raised onClick={this.onHandleSubmit} disabled={this.state.saveDisable}>Notify</Button>
          	</GridCell>
          	{noteComponent}
          	<GridCell span="12">
          		<StatusMessage error_msg = {this.state.errorMsg}/>
          	</GridCell>
          </Grid>
				</Card>
			</div>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminTriggerEmailNotification);




// WEBPACK FOOTER //
// ./src/views/admin/AdminTriggerEmailNotification.jsx